// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { getIconPath, isCanada, isMobileWeb } from '@tcp/core/src/utils';
import DynamicFreeSippingModal from '@tcp/core/src/components/common/organisms/ProductPickup/views/DynamicFreeSipping.modal.view';
import QuickAddFreeShippingRecsModal from '../../QuickAddFreeShippingRecsModal/views/QuickAddFreeShippingRecsModal.view';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from '../styles/FreeShippingProgressBar.style';
import Anchor from '../../../../../../common/atoms/Anchor';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblDetails,
  lblCreditCard,
} from '../../../../../../../utils/labels/globalGeneric.labels';
import FreeShippingProgressBarLabels, {
  CHECKOUT_LABELS,
} from '../labels/FreeShippingProgressBar.labels';
import {
  getQuickAddFreeShippingRecsThreshold,
  getIsQuickAddFreeShippingRecsEnabled,
  getQuickAddFreeShippingRecsThresholdA,
  getQuickAddFreeShippingRecsThresholdB,
  getQuickAddFreeShippingRecsThresholdC,
} from '../../../../../../../reduxStore/selectors/session.selectors';
import {
  setQuickAddModalRecsType,
  setQuickAddModalStateActn,
} from '../../../../BagPage/container/BagPage.actions';
import { getIsQuickAddModalOpen } from '../../../../BagPage/container/BagPage.selectors';

const getRecommendationType = ({
  amountLeftToAttainFreeShipping,
  quickAddFreeShippingRecsThresholdA,
  quickAddFreeShippingRecsThresholdB,
  quickAddFreeShippingRecsThresholdC,
  quickAddFreeShippingRecsThreshold,
}) => {
  let quickAddRecType;
  if (amountLeftToAttainFreeShipping < quickAddFreeShippingRecsThresholdA) {
    quickAddRecType = 'ab_cart_shipping_a';
  } else if (amountLeftToAttainFreeShipping < quickAddFreeShippingRecsThresholdB) {
    quickAddRecType = 'ab_cart_shipping_b';
  } else if (amountLeftToAttainFreeShipping < quickAddFreeShippingRecsThresholdC) {
    quickAddRecType = 'ab_cart_shipping_c';
  } else if (
    amountLeftToAttainFreeShipping >= quickAddFreeShippingRecsThresholdC &&
    amountLeftToAttainFreeShipping <= quickAddFreeShippingRecsThreshold
  ) {
    quickAddRecType = 'ab_cart_shipping_c';
  }
  return quickAddRecType;
};

const getIsShowQuickAddModal = (
  hasFreeShipping,
  fromATBDrawer,
  quickAddFreeShippingRecsThreshold,
  isQuickAddFreeShippingRecsEnabled,
  amountLeftToAttainFreeShipping
) => {
  return (
    !hasFreeShipping &&
    !fromATBDrawer &&
    isQuickAddFreeShippingRecsEnabled &&
    quickAddFreeShippingRecsThreshold > 0 &&
    amountLeftToAttainFreeShipping > 0 &&
    amountLeftToAttainFreeShipping <= quickAddFreeShippingRecsThreshold
  );
};

class FreeShippingProgressBar extends React.PureComponent {
  checkoutLabels = getLabelFromCopyOrFromTranslation(
    CHECKOUT_LABELS,
    FreeShippingProgressBarLabels
  );

  constructor(props) {
    super(props);
    this.state = { isDFSModalOpen: false };
  }

  componentWillUnmount() {
    const { setQuickAddModalState, isQuickAddModalOpen } = this.props;
    if (isQuickAddModalOpen) setQuickAddModalState(false);
  }

  replaceAndFormatShippingValue(originalText, replacementValue, fontWeight) {
    const replacedText = originalText?.replace(/#shippingValue/g, replacementValue);
    const parts = replacedText?.split(replacementValue);
    return (
      <span>
        {parts[0]}
        <span style={{ fontWeight }}>{`$${replacementValue}`}</span>
        {parts[1]}
      </span>
    );
  }

  detailClick = (e) => {
    e.preventDefault();
    const { isDFSModalOpen } = this.state;
    this.setState({ isDFSModalOpen: !isDFSModalOpen });
  };

  hideBoss = () => {
    const { isBossEnabled } = this.props;
    return isCanada() || !isBossEnabled;
  };

  getTextSize = (isMobile) => {
    return isMobile ? 'fs12' : 'fs14';
  };

  getFreeShippingMessageBasedOnPromo = (freeShippingPromoType) => {
    const isMobile = isMobileWeb();
    const textSize = this.getTextSize(isMobile);
    return (
      <BodyCopy
        className="free-shipping-progress-bar-text-wrapper"
        component="div"
        fontFamily="secondary"
        fontSize={textSize}
      >
        <span>
          <BodyCopy
            fontFamily="secondary"
            fontSize={textSize}
            fontWeight="extrabold"
            component="span"
            textAlign="center"
          >
            {getDynamicLabelValues('dynamic.cart.lbl_free_shipping_coupon_msg1')}
          </BodyCopy>
          <BodyCopy
            fontFamily="secondary"
            fontSize={textSize}
            fontWeight="normal"
            component="span"
            textAlign="center"
          >
            {`${getDynamicLabelValues('dynamic.cart.lbl_free_shipping_promo_msg1')} `}
          </BodyCopy>
        </span>
        <span className="coupon-free-shipping-text">{`${renderLabel(
          this.checkoutLabels?.bagPage?.lbl_freeShipping_cartTile,
          'lbl_freeShipping_cartTile'
        )?.toUpperCase()} `}</span>
        <BodyCopy
          fontFamily="secondary"
          fontSize={textSize}
          fontWeight="normal"
          component="span"
          textAlign="center"
        >
          {`${getDynamicLabelValues('dynamic.cart.lbl_free_shipping_promo_msg2')} `}
        </BodyCopy>
        {isCanada() ? (
          <BodyCopy
            component="span"
            fontWeight="extrabold"
            fontSize={textSize}
            fontFamily="secondary"
          >
            {'My Place Account'}
          </BodyCopy>
        ) : (
          <>
            <BodyCopy
              component="span"
              fontWeight="extrabold"
              fontSize={textSize}
              className="text-style-1"
              fontFamily="secondary"
            >
              {'My '}
            </BodyCopy>
            <BodyCopy
              component="span"
              fontWeight="extrabold"
              fontSize={textSize}
              className="text-style-2"
              fontFamily="secondary"
            >
              {'Place '}
            </BodyCopy>

            <BodyCopy
              component="span"
              fontWeight="extrabold"
              fontSize={textSize}
              className="text-style-3"
              fontFamily="secondary"
            >
              {'Reward$ '}
            </BodyCopy>
            <BodyCopy
              component="span"
              fontWeight="extrabold"
              fontSize={textSize}
              className="text-style-4"
              fontFamily="secondary"
            >
              {freeShippingPromoType === 'mpr'
                ? 'account.'
                : `${getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_GENERIC_LABELS}.${lblCreditCard}`,
                    GlobalGenericLabels
                  )}.`}
            </BodyCopy>
          </>
        )}
      </BodyCopy>
    );
  };

  getFreeShippingMessage = ({ hasFreeShipping, amountLeftToAttainFreeShipping }) => {
    const { isMixedOrder, isFreeShippingCouponApplied } = this.props;
    const isMobile = isMobileWeb();
    const textSize = this.getTextSize(isMobile);
    const shippingLabel = `${getDynamicLabelValues(
      'dynamic.cart.lbl_free_shipping_msg'
    )} #shippingValue ${getDynamicLabelValues('dynamic.cart.lbl_free_shipping_away_msg')} `;
    return (
      <div>
        {isFreeShippingCouponApplied ? (
          <BodyCopy
            className="free-shipping-progress-bar-text-wrapper"
            component="div"
            fontFamily="secondary"
            fontSize={textSize}
          >
            <span>
              <BodyCopy
                fontFamily="secondary"
                fontSize={textSize}
                fontWeight="extrabold"
                component="span"
                textAlign="center"
              >
                {getDynamicLabelValues('dynamic.cart.lbl_free_shipping_coupon_msg1')}
              </BodyCopy>
              {getDynamicLabelValues('dynamic.cart.lbl_free_shipping_coupon_msg2')}
            </span>
            <span className="coupon-free-shipping-text">{`${renderLabel(
              this.checkoutLabels?.bagPage?.lbl_freeShipping_cartTile,
              'lbl_freeShipping_cartTile'
            )?.toUpperCase()} `}</span>
            <span>{getDynamicLabelValues('dynamic.cart.lbl_free_shipping_coupon_msg3')}</span>
          </BodyCopy>
        ) : (
          <BodyCopy
            className="free-shipping-progress-bar-text-wrapper"
            component="div"
            fontFamily="secondary"
          >
            {!hasFreeShipping
              ? this.replaceAndFormatShippingValue(
                  shippingLabel,
                  amountLeftToAttainFreeShipping?.toFixed(2),
                  800
                )
              : `${getDynamicLabelValues('dynamic.cart.lbl_free_shipping_success_msg1')} `}
            <span>
              <span className="free-shipping-text">{`${renderLabel(
                this.checkoutLabels?.bagPage?.lbl_freeShipping_cartTile,
                'lbl_freeShipping_cartTile'
              )?.toUpperCase()}${
                (isMixedOrder && !hasFreeShipping) || hasFreeShipping ? '' : '!'
              } `}</span>
              {!hasFreeShipping &&
                isMixedOrder &&
                `${getDynamicLabelValues('dynamic.cart.lbl_free_shipping_success_msg2')} `}
              {hasFreeShipping &&
                `${getDynamicLabelValues('dynamic.cart.lbl_free_shipping_success_msg3')} `}
              <Anchor
                noLink
                handleLinkClick={this.detailClick}
                title={renderLabel(
                  getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_GENERIC_LABELS}.${lblDetails}`,
                    GlobalGenericLabels
                  ),
                  'lbl_details'
                )}
                className="free-ship-anchor"
                underline
              >
                {renderLabel(
                  getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_GENERIC_LABELS}.${lblDetails}`,
                    GlobalGenericLabels
                  ),
                  'lbl_details'
                )}
              </Anchor>
            </span>
          </BodyCopy>
        )}
      </div>
    );
  };

  render() {
    const {
      className,
      shipments,
      freeShippingThreshold,
      dynamicShippingCharge,
      shippingFreePercentage,
      fromATBDrawer,
      isFreeShippingCouponApplied,
      quickAddFreeShippingRecsThreshold,
      isQuickAddFreeShippingRecsEnabled,
      isQuickAddModalOpen,
      setQuickAddModalState,
      freeShippingPromoType,
      freeShippingMessageForPromosEnabled,
      quickAddFreeShippingRecsThresholdA,
      quickAddFreeShippingRecsThresholdB,
      quickAddFreeShippingRecsThresholdC,
      setQuickAddModalRecsTypeAction,
    } = this.props;
    const shippingDetails = shipments?.filter((shipment) => shipment?.c_fromStoreId === null)[0];
    const amountLeftToAttainFreeShipping =
      freeShippingThreshold - shippingDetails?.productTotal || 0;
    const hasFreeShipping = shippingFreePercentage >= 100 || isFreeShippingCouponApplied;
    const { isDFSModalOpen } = this.state;
    const isShowQuickAddButton = getIsShowQuickAddModal(
      hasFreeShipping,
      fromATBDrawer,
      quickAddFreeShippingRecsThreshold,
      isQuickAddFreeShippingRecsEnabled,
      amountLeftToAttainFreeShipping
    );
    const recommendationType = getRecommendationType({
      amountLeftToAttainFreeShipping,
      quickAddFreeShippingRecsThresholdA,
      quickAddFreeShippingRecsThresholdB,
      quickAddFreeShippingRecsThresholdC,
      quickAddFreeShippingRecsThreshold,
    });
    const isMobile = isMobileWeb();
    if (
      freeShippingThreshold <= 0 &&
      !(freeShippingPromoType === 'plcc' || freeShippingPromoType === 'mpr')
    ) {
      return null;
    }
    return (
      <div className={className}>
        <div className="free-shipping-progress-bar-wrapper">
          <div className="free-shipping-progress-bar-header">
            <Image
              className="header-icon elem-pr-XS"
              width="24px"
              height="18px"
              src={getIconPath('shipping-section')}
              aria-hidden="true"
            />
            <BodyCopy
              fontWeight="bold"
              fontFamily="secondary"
              fontSize={fromATBDrawer && !isMobile ? 'fs14' : 'fs16'}
              component="span"
              className="header-free-shipping"
              textAlign="center"
            >
              {getDynamicLabelValues('dynamic.cart.lbl_free_shipping_progress_bar_header')}
            </BodyCopy>
          </div>
          <div className="free-shipping-progress-content">
            {(hasFreeShipping || freeShippingThreshold === 0) &&
            !isFreeShippingCouponApplied &&
            freeShippingMessageForPromosEnabled &&
            (freeShippingPromoType === 'plcc' || freeShippingPromoType === 'mpr') ? (
              this.getFreeShippingMessageBasedOnPromo(freeShippingPromoType)
            ) : (
              <div>
                {this.getFreeShippingMessage({ hasFreeShipping, amountLeftToAttainFreeShipping })}
              </div>
            )}
            {freeShippingThreshold > 0 && (
              <div className="progress-bar-wrapper">
                <div className="progress-wrapper" />
              </div>
            )}
          </div>
          {isShowQuickAddButton ? (
            <div className="quick-add-button-wrapper">
              <div className="quick-add-text">We picked some items for you!</div>
              <button
                onClick={(e) => {
                  e?.preventDefault();
                  setQuickAddModalState(true);
                  setQuickAddModalRecsTypeAction(recommendationType);
                }}
                className="quick-add-button"
              >
                <span className="quick-add-button-plus">+</span>{' '}
                <span className="quick-add-button-text">ADD ITEM</span>
              </button>
            </div>
          ) : null}
        </div>
        <DynamicFreeSippingModal
          openState={isDFSModalOpen}
          onRequestClose={() => {
            this.setState({
              isDFSModalOpen: false,
            });
          }}
          freeShippingThreshold={freeShippingThreshold}
          dynamicShippingCharge={dynamicShippingCharge}
          showShipToStoreMsg={!this.hideBoss()}
        />
        {isQuickAddModalOpen && (
          <QuickAddFreeShippingRecsModal
            isQuickAddModalOpen={isQuickAddModalOpen}
            onRequestClose={() => {
              setQuickAddModalState(false);
            }}
          />
        )}
      </div>
    );
  }
}

FreeShippingProgressBar.propTypes = {
  className: PropTypes.string.isRequired,
  setQuickAddModalState: PropTypes.func,
  isQuickAddModalOpen: PropTypes.bool,
};
FreeShippingProgressBar.defaultProps = {
  setQuickAddModalState: () => {},
  isQuickAddModalOpen: false,
};

export const mapStateToProps = (state) => {
  return {
    quickAddFreeShippingRecsThreshold: getQuickAddFreeShippingRecsThreshold(state),
    quickAddFreeShippingRecsThresholdA: getQuickAddFreeShippingRecsThresholdA(state),
    quickAddFreeShippingRecsThresholdB: getQuickAddFreeShippingRecsThresholdB(state),
    quickAddFreeShippingRecsThresholdC: getQuickAddFreeShippingRecsThresholdC(state),
    isQuickAddFreeShippingRecsEnabled: getIsQuickAddFreeShippingRecsEnabled(state),
    isQuickAddModalOpen: getIsQuickAddModalOpen(state),
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    setQuickAddModalState: (payload) => {
      dispatch(setQuickAddModalStateActn(payload));
    },
    setQuickAddModalRecsTypeAction: (payload) => {
      dispatch(setQuickAddModalRecsType(payload));
    },
  };
};

export default withStyles(
  connect(mapStateToProps, mapDispatchToProps)(FreeShippingProgressBar),
  styles
);
export { FreeShippingProgressBar as FreeShippingProgressBarVanilla };
